export enum PublicIssueType {
  Issue = 'ISSUE',
  Complaint = 'COMPLAINT',
}
